import { render, staticRenderFns } from "./AsistenteIA.vue?vue&type=template&id=2342190d&scoped=true"
import script from "./AsistenteIA.vue?vue&type=script&lang=js"
export * from "./AsistenteIA.vue?vue&type=script&lang=js"
import style0 from "./AsistenteIA.vue?vue&type=style&index=0&id=2342190d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2342190d",
  null
  
)

export default component.exports